module.exports = __webpack_public_path__ + "img/reatil-trade-icon.9a637898.svg";